export default __webpack_public_path__ + "static/media/IBMPDF.4005f296.svg";